import { render, staticRenderFns } from "./parts-list-group-items.vue?vue&type=template&id=2bf90775&"
import script from "./parts-list-group-items.vue?vue&type=script&lang=ts&"
export * from "./parts-list-group-items.vue?vue&type=script&lang=ts&"
import style0 from "./parts-list-group-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
